<!--
 * @Author: qin 15936669602@163.com
 * @Date: 2025-07-13 11:50:28
 * @LastEditors: qin 15936669602@163.com
 * @LastEditTime: 2025-07-14 22:42:28
 * @FilePath: /360-house-viewing-main/src/components/Back.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <!-- 顶部导航栏 -->
    <div class="topbar">
      <a @click="goBack" class="back-btn" style="cursor: pointer">
        <i class="fas fa-arrow-left"></i>返回
      </a>
      <div class="tips">
        欢迎回到智训立方课程空间。您可以在这里维护课程内容、组织案例学习和查看训练反馈。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    backUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    goBack() {
      // 如果有指定的返回路径，优先使用
      if (this.backUrl) {
        this.$router.push(this.backUrl);
        return;
      }

      // 检查是否有历史记录可以返回
      if (window.history.length > 1) {
        // 使用 router.go(-1) 返回上一个路由
        this.$router.go(-1);
      } else {
        // 如果没有历史记录，返回首页
        this.$router.push("/");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.topbar {
  min-height: 50px;
  margin-bottom: 20px;
  padding: 12px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(226, 232, 240, 0.92);
  box-shadow: var(--shadow-soft);
}

.back-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 13px;
  border-radius: 999px;
  background: rgba(47, 111, 237, 0.10);
  color: var(--secondary-color);
  text-decoration: none;
  font-size: 14px;
  font-weight: 800;
  transition: all 0.22s ease;

  &:hover {
    color: #fff;
    background: var(--secondary-color);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(1px);
  }
}

.back-btn i {
  margin-right: 0;
}

.tips {
  flex: 1;
  color: var(--gray-text);
  font-size: 14px;
  line-height: 1.7;
  text-align: right;
}

@media (max-width: 768px) {
  .topbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .tips {
    text-align: left;
  }
}
</style>
